import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

type Item = {
  label: string;
  href: string;
};

type LinksProps = {
  items: Item[];
  title?: string;
  whatsapp: string;
};

const Links = ({ items, title, whatsapp }: LinksProps) => {
  if (Array.isArray(items) && items.length > 0) {
    const handleNavigate = (message: string) => {
      const url = `https://wa.me/${whatsapp}?text=${message}`;
      window.open(url, "_blank");
    };

    return (
      <section id="links">
        <Stack rowGap={2}>
          {title && (
            <Typography color="primary" variant="h6" fontWeight={500}>
              {title}
            </Typography>
          )}
          {items.map((item, key) => (
            <Box
              onClick={() => {
                if (item.href) {
                  window.open(item.href, "_blank");
                } else {
                  handleNavigate(item.label);
                }
              }}
              key={key.toString()}
              bgcolor="#FFF"
              borderRadius="8px"
              px={4}
              py={2}
              sx={{ cursor: "pointer" }}
            >
              <Typography color="secondary" variant="button">
                {item.label}
              </Typography>
            </Box>
          ))}
        </Stack>
      </section>
    );
  }

  return <></>;
};

export default Links;
